import { createVNode as _createVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, createCommentVNode as _createCommentVNode, Transition as _Transition, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-aa1b4b92")

_pushScopeId("data-v-aa1b4b92")
const _hoisted_1 = { class: "mobile-loby-root" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = { class: "info-1" }
const _hoisted_4 = /*#__PURE__*/_createVNode("span", { class: "icon icon-user" }, null, -1)
const _hoisted_5 = { class: "label" }
const _hoisted_6 = { class: "info-2" }
const _hoisted_7 = { class: "label" }
const _hoisted_8 = { class: "setting" }
const _hoisted_9 = { class: "tab" }
const _hoisted_10 = { class: "content" }
const _hoisted_11 = { class: "list" }
const _hoisted_12 = { class: "footer" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_app_svg = _resolveComponent("app-svg")
  const _component_list_item = _resolveComponent("list-item")
  const _component_marquee_text = _resolveComponent("marquee-text")
  const _component_mobile_setting_dialog_view = _resolveComponent("mobile-setting-dialog-view")
  const _component_change_password_view = _resolveComponent("change-password-view")
  const _component_bet_history = _resolveComponent("bet-history")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _hoisted_4,
        _createVNode("span", _hoisted_5, _toDisplayString(_ctx.userId), 1)
      ]),
      _createVNode("div", _hoisted_6, [
        _createVNode(_component_app_svg, {
          box: '0 0 18.067 18.066',
          id: 'coin',
          className: 'coin-svg',
          fill: 'rgb(221, 194, 140)',
          stroke: 'rgb(221, 194, 140)'
        }, null, 8, ["box", "fill", "stroke"]),
        _createVNode("span", _hoisted_7, _toDisplayString(_ctx.betCoin), 1)
      ]),
      _createVNode("div", _hoisted_8, [
        _createVNode("span", {
          class: "icon icon-setting",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showSettings = true))
        })
      ])
    ]),
    _createVNode("ul", _hoisted_9, [
      _createVNode("li", {
        class: { active: _ctx.selectedTab === 3 },
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onSelectTab(3)))
      }, _toDisplayString(_ctx.iN('common.allgames')), 3),
      _createVNode("li", {
        class: { active: _ctx.selectedTab === 1 },
        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.onSelectTab(1)))
      }, _toDisplayString(_ctx.iN('common.baccarat')), 3),
      _createVNode("li", {
        class: { active: _ctx.selectedTab === 2 },
        onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.onSelectTab(2)))
      }, _toDisplayString(_ctx.iN('common.dragontiger')), 3)
    ]),
    _createVNode("div", _hoisted_10, [
      _createVNode("div", _hoisted_11, [
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.listData, (i) => {
          return (_openBlock(), _createBlock(_component_list_item, {
            class: "item",
            key: i.deskId,
            deskData: i,
            itemIndex: i.deskId,
            selectedIndex: _ctx.selectedIndex,
            onClick: ($event: any) => (_ctx.selectItem(i.deskId))
          }, null, 8, ["deskData", "itemIndex", "selectedIndex", "onClick"]))
        }), 128))
      ])
    ]),
    _createVNode("div", _hoisted_12, [
      _createVNode(_component_marquee_text, {
        class: "m-notice",
        key: _ctx.infoKey,
        animate: !_ctx.noticeIsPaused,
        speed: 30
      }, {
        default: _withId(() => [
          _createTextVNode(_toDisplayString(_ctx.notice), 1)
        ]),
        _: 1
      }, 8, ["animate"])
    ]),
    _createVNode(_Transition, { name: "fadein-out" }, {
      default: _withId(() => [
        (_ctx.showSettings)
          ? (_openBlock(), _createBlock(_component_mobile_setting_dialog_view, {
              key: 0,
              class: "full-dialog",
              onOnClose: _cache[5] || (_cache[5] = ($event: any) => (_ctx.showSettings = false)),
              onOnShowChangePasswordForm: _cache[6] || (_cache[6] = ($event: any) => (_ctx.showPasswordForm = true)),
              onOnShowHistory: _cache[7] || (_cache[7] = ($event: any) => (_ctx.showHistory = true))
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_Transition, { name: "fadein-out" }, {
      default: _withId(() => [
        (_ctx.showPasswordForm)
          ? (_openBlock(), _createBlock(_component_change_password_view, {
              key: 0,
              class: "full-dialog",
              onOnClose: _cache[8] || (_cache[8] = ($event: any) => (_ctx.showPasswordForm = false))
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_Transition, { name: "fadein-out" }, {
      default: _withId(() => [
        (_ctx.showHistory)
          ? (_openBlock(), _createBlock(_component_bet_history, {
              key: 0,
              class: "full-dialog",
              onOnClose: _cache[9] || (_cache[9] = ($event: any) => (_ctx.showHistory = false))
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
})